import {
	type BuilderCtx,
	CAP,
	type Collection,
	placeDistances,
} from './shared.ts'

// Place activities a short drive away — beyond walking, up to 25 miles.
export const buildDrivingRow = ({
	activities,
	origin,
}: BuilderCtx): Collection | null => {
	if (!origin) return null
	return {
		key: 'driving',
		title: 'A short drive away',
		activities: placeDistances(activities, origin)
			.filter((p) => p.miles > 1 && p.miles <= 25)
			.map((p) => p.activity)
			.slice(0, CAP),
		seeAll: { where: 'place', maxDistanceMiles: 25 },
	}
}
